export default __webpack_public_path__ + "static/media/bocci-icon.ccbb6ebc.svg";